(function(){
    'use strict'

    angular
    .module('app.areas')
    .controller('EditarArea', EditarArea);

    EditarArea.$inject = ['$scope', '$animationsSrv', '$routeParams','AreasService', 'CentrosCostoService', 'logger', '$location', 'UserInfoService'];

    function EditarArea($scope, $animationsSrv, $routeParams, AreasService, CentrosCostoService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centrosCosto = [];
        vm.area = {
            centroCostoId: -1
        };

        vm.areaId = $routeParams.id ? $routeParams.id : 0;

        var promiseCentroCosto = getCentrosCosto();

        if(vm.areaId){
            getArea(promiseCentroCosto);
        }

        function getCentrosCosto(){
            var promise = CentrosCostoService.getAll(UserInfoService.getCompaniaId())
            .then(function(centrosCosto){
                vm.centrosCosto = centrosCosto;
            })
            .catch(function(error){
                $logger.error('Error al obtener los centros de costo')
            }); 
            
            return promise;
        }

        function getArea(promiseCentroCosto){

            promiseCentroCosto.then(function(){
                if(vm.areaId != 0){
                    var promise = AreasService.getById(UserInfoService.getCompaniaId(), vm.areaId);
    
                    promise
                    .then(function(area){
                        vm.area = area;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el area: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            });

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.areaForm.$valid){
                if(!vm.area.id){
                    saveArea();
                }
                else if($scope.areaForm.$dirty){
                    updateArea();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveArea() {
            var promise = AreasService.save(vm.area);
            
            promise
            .then(function(response){
                logger.success('Area creado con éxito.');
                clearAreaData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el area: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateArea(){
            var promise = AreasService.update(vm.area);
            
            promise
            .then(function(response){
                logger.success('Area modificado con éxito.');
                $location.path('/areas');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el area: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearAreaData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.area = {
                centroCostoId: -1
            };
            // Set back to pristine.
            $scope.areaForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.areaForm.$setUntouched();
        };

    }
})();